/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/sort-comp */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable class-methods-use-this */
import * as React from 'react';
import { Swipeable } from 'react-swipeable';
import throttle from 'lodash/throttle';
// import { UserManagementAnalytics } from '@UserManagement/Shared/utils/UserManagementAnalytics';

// const analytics = new UserManagementAnalytics();

type Direction = 'prev' | 'next';

type SwipeEventData = {
  event: Event;
  dir: 'Left' | 'Right' | 'Up' | 'Down';
};

type ModalItem = {
  id: number;
  name: string;
  description: string;
  imgurl: string;
};

export interface CarouselProps {
  render: (item: ModalItem, index: number) => React.ReactNode;
  items: ModalItem[];
  showIndicators?: boolean;
  analyticsCall?: boolean;
  analyticsText?: string;
}

export interface CarouselState {
  offsetStart: number;
  activeIndex: number;
  isPrevButton: boolean;
  isNextButton: boolean;
}

export class SimpleCarousel extends React.Component<
  CarouselProps,
  CarouselState
> {
  constructor(props: CarouselProps) {
    super(props);
    this.state = {
      offsetStart: 0,
      activeIndex: 0,
      isPrevButton: false,
      isNextButton: true,
    };
    this.goToBtnNav = this.goToBtnNav.bind(this);
    this.showHideNavButtons = this.showHideNavButtons.bind(this);
    this.goToSlide = this.goToSlide.bind(this);
  }

  itemRef: React.RefObject<HTMLLIElement> = React.createRef();

  itemCollectionRef: React.RefObject<HTMLUListElement> = React.createRef();

  CURRENT_ITEM_WIDTH = 100;

  getCurrentTotalItemsWidth = () => {
    return this.CURRENT_ITEM_WIDTH * this.props.items.length;
  };

  goToBtnNav = (direction: Direction) => {
    const { items } = this.props;
    const itemsLength = items.length - 1;
    let itemWidth = this.CURRENT_ITEM_WIDTH;
    itemWidth = direction === 'prev' ? itemWidth : -itemWidth;
    const { prevBtn, nextBtn, index } = this.showHideNavButtons(
      direction,
      itemsLength,
    );
    this.setState({
      offsetStart: this.state.offsetStart + itemWidth,
      activeIndex: index,
      isPrevButton: prevBtn,
      isNextButton: nextBtn,
    });
  };

  showHideNavButtons(
    direction: Direction,
    itemsLength: number,
    nextIndex?: number,
  ) {
    let prevBtn = false;
    let nextBtn = false;
    const index = nextIndex ?? this.updateIndicator(direction, itemsLength);
    if (index === 0) {
      prevBtn = false;
      nextBtn = true;
    } else if (index === itemsLength) {
      nextBtn = false;
      prevBtn = true;
    } else {
      nextBtn = true;
      prevBtn = true;
    }
    return { prevBtn, nextBtn, index };
  }

  updateIndicator = (direction: Direction, itemsLength: number) => {
    let prevIndex = this.state.activeIndex;
    if (prevIndex >= 0 && prevIndex <= itemsLength) {
      prevIndex += direction === 'prev' ? -1 : +1;
    }
    return prevIndex;
  };

  swipeAnalytic = () => {
    // TODO
    // analytics?.pushMyAccountButtonEvent(this.props.analyticsText);
  };

  handleSwipe = throttle(
    (event: SwipeEventData) => {
      if (this.props.analyticsCall) {
        this.swipeAnalytic();
      }
      const touchDirection = event.dir === 'Left' ? 'next' : 'prev';
      const itemsLength = this.props.items.length - 1;
      const index = this.updateIndicator(touchDirection, itemsLength);
      if (index >= 0 && index <= itemsLength) {
        this.goToBtnNav(touchDirection);
      }
    },
    500,
    { trailing: false },
  );

  goToSlide(event: React.MouseEvent<HTMLButtonElement>) {
    const itemsLength = this.props.items.length - 1;
    const currentIndex = this.state.activeIndex;
    const nextIndex = Number(event.currentTarget.dataset.index);
    if (currentIndex !== nextIndex) {
      const direction = currentIndex < nextIndex ? 'next' : 'prev';
      const itemWidth = this.CURRENT_ITEM_WIDTH * nextIndex;
      const { prevBtn, nextBtn } = this.showHideNavButtons(
        direction,
        itemsLength,
        nextIndex,
      );
      this.setState(() => {
        const newOffsetStart = 0;
        return {
          offsetStart: newOffsetStart - itemWidth,
          activeIndex: nextIndex,
          isPrevButton: prevBtn,
          isNextButton: nextBtn,
        };
      });
    }
  }

  render() {
    const styleAttributes = {
      transform: `translateX(${this.state.offsetStart}%)`,
      transition: 'all 350ms ease-out',
    };
    return (
      <div
        className="simple-carousel-container sui-relative sui-w-full sui-overflow-hidden sui-flex sui-flex-col sui-justify-between sui-h-full"
        data-testid="simple-carousel-container"
      >
        <Swipeable
          onSwipedLeft={(event: SwipeEventData) => this.handleSwipe(event)}
          onSwipedRight={(event: SwipeEventData) => this.handleSwipe(event)}
        >
          <ul
            data-testid="carousel-slides-ul"
            className="sui-relative sui-w-full sui-flex sui-flex-row sui-flex-nowrap sui-list-none sui-y-4"
            ref={this.itemCollectionRef}
            style={styleAttributes}
          >
            {this.props.items?.map((item, index) => (
              <li
                data-testid="carousel-slide-li"
                style={{ minWidth: '100%' }}
                key={index}
                ref={this.itemRef}
              >
                {this.props.render(item, index)}
              </li>
            ))}
          </ul>
        </Swipeable>
        {this.props.showIndicators && (
          <ul
            data-testid="carousel-indicators-ul"
            className="sui-list-none sui-flex sui-flex-row sui-justify-center sui-mb-3"
          >
            {this.props.items?.map((item, index) => (
              <li
                className="sui-px-2"
                key={index}
                data-testid="carousel-indicator-li"
              >
                <button
                  type="button"
                  data-index={index}
                  data-item={item}
                  aria-label="carousel"
                  className="sui-rounded-full transition-opacity duration-150 ease-[cubic-bezier(0.4, 0, 1, 1)] cursor-pointer"
                  style={{
                    width: '11px',
                    height: '11px',
                    background: `${
                      index === this.state.activeIndex ? '#FF9632' : '#D8D8D8'
                    }`,
                  }}
                  onClick={this.goToSlide}
                >
                  &nbsp;
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}
